import { render, staticRenderFns } from "./MultiCheckboxSelect.vue?vue&type=template&id=3c2a8d14&"
import script from "./MultiCheckboxSelect.vue?vue&type=script&lang=js&"
export * from "./MultiCheckboxSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports